export default __webpack_public_path__ + "static/media/spinner2.7846e680.gif";